module.exports = __webpack_public_path__ + "img/rogue20.554cf0f6.png";